import { getPlans } from "../lib/api";
import { useApi } from "../lib/useApi";
import { formatDateShort, parseJson } from "../lib/format";
import { TopBar } from "../components/Layout";
import { EmptyState, ErrorState, Loading } from "../components/States";

interface PlanLimits {
  seats?: number;
  projects?: number;
  storage_mb?: number;
}
interface PlanFeatures {
  [k: string]: boolean;
}

export function PlansPage() {
  const { data, loading, error, reload } = useApi((signal) => getPlans(signal), []);
  const plans = data?.plans ?? [];

  return (
    <>
      <TopBar
        crumbs="Plans"
        actions={
          <button className="btn" onClick={reload} disabled={loading}>
            Refresh
          </button>
        }
      />
      <div className="content">
        <div className="page-head">
          <div>
            <h1>Plans</h1>
            <div className="sub">Reference pricing tiers seeded in the control plane.</div>
          </div>
        </div>

        <div className="card">
          <div className="card-body tight">
            {loading ? (
              <Loading label="Loading plans…" />
            ) : error ? (
              <ErrorState error={error} onRetry={reload} />
            ) : plans.length === 0 ? (
              <EmptyState>No plans configured.</EmptyState>
            ) : (
              <table className="data">
                <thead>
                  <tr>
                    <th>Plan</th>
                    <th>Code</th>
                    <th>Seats</th>
                    <th>Projects</th>
                    <th>Storage</th>
                    <th>Features</th>
                    <th>Active</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {plans.map((p) => {
                    const limits = parseJson<PlanLimits>(p.limits_json) ?? {};
                    const features = parseJson<PlanFeatures>(p.features_json) ?? {};
                    const enabled = Object.entries(features)
                      .filter(([, v]) => v)
                      .map(([k]) => k);
                    return (
                      <tr key={p.id}>
                        <td>
                          <strong>{p.name}</strong>
                        </td>
                        <td className="mono">{p.code}</td>
                        <td className="num">{limits.seats ?? "—"}</td>
                        <td className="num">{limits.projects ?? "—"}</td>
                        <td className="num">
                          {limits.storage_mb != null
                            ? `${(limits.storage_mb / 1000).toLocaleString()} GB`
                            : "—"}
                        </td>
                        <td>
                          {enabled.length ? (
                            <div className="tag-list">
                              {enabled.map((f) => (
                                <span key={f} className="pill">
                                  {f}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <span className="faint">—</span>
                          )}
                        </td>
                        <td>{p.active ? "Yes" : "No"}</td>
                        <td className="num">{formatDateShort(p.created_at)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
